// TODO: Implement player services and uncomment related code

import React from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Chip,
  Grid,
  Divider,
  Alert,
  Snackbar,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  ArrowBack as ArrowBackIcon,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import {
//   getPlayerEntries,
//   deletePlayer,
//   getPlayerByBsa,
// } from "../services/players";
// import { deleteEntry } from "../services/entries";

import AddEntryDialog from "../entries/addEntryDialog";
import BowlScoutImage from "../resources/images/Bowls Master Logo.png";
import ActivityTable from "../components/ActivityTable";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

import { deleteEntry } from "../features/entry/entrySlice";

// Helper function to format dates
const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB"); // DD/MM/YYYY format
};

function Player() {
  const dispatch = useDispatch();
  const { bsa_number } = useParams();
  const navigate = useNavigate();
  const { user } = useKindeAuth();

  // Extract user name from auth metadata
  const getUserName = (user) => {
    if (!user) return null;

    return (
      user.user_metadata?.full_name ||
      user.user_metadata?.name ||
      (user.user_metadata?.first_name && user.user_metadata?.last_name
        ? `${user.user_metadata.first_name} ${user.user_metadata.last_name}`
        : null) ||
      user.email ||
      "Unknown User"
    );
  };

  // Player state
  const [player, setPlayer] = useState(null);
  const [editingPlayer, setEditingPlayer] = useState(false);
  const [playerForm, setPlayerForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    bsa_number: "",
  });

  // Entries state
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [entryDialog, setEntryDialog] = useState({
    open: false,
    editEntry: null, // null for add mode, entry object for edit mode
  });

  // Dialog states
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    type: null,
    item: null,
  });

  // Feedback state
  const [feedback, setFeedback] = useState({
    open: false,
    message: "",
    severity: "success", // "success" | "error" | "warning" | "info"
  });

  // Deleting state
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const fetchPlayerData = async () => {
      try {
        setLoading(true);
        console.log("Fetching player data for BSA number:", bsa_number);

        // Use the BSA number from URL parameter to get player details
        //const playerResponse = await getPlayerByBsa(bsa_number);
        //console.log("Player response received:", playerResponse);

        // if (playerResponse && playerResponse.player) {
        //   const playerData = {
        //     id: playerResponse.player.id,
        //     firstName: playerResponse.player.firstName || "Unknown",
        //     lastName: playerResponse.player.lastName || "Player",
        //     email: playerResponse.player.email || "",
        //     bsa_number: playerResponse.player.bsa_number || "",
        //     rank: playerResponse.player.rank,
        //     total_points: playerResponse.player.total_points,
        //     qualifying_events: Array.isArray(
        //       playerResponse.player.qualifying_events
        //     )
        //       ? playerResponse.player.qualifying_events.length
        //       : playerResponse.player.qualifying_events || 0,
        //   };

        //   console.log("Setting player data:", playerData);
        //   setPlayer(playerData);
        //   setPlayerForm(playerData);

        //   // Fetch entries using the actual player ID
        //   //const entriesData = await getPlayerEntries(playerData.id);
        //   console.log("Entries data:", entriesData);
        //   setEntries(entriesData || []);
        // } else {
        //   // Handle case where player not found
        //   console.log("Player not found in response");
        //   setPlayer(null);
        // }
      } catch (error) {
        console.error("Error fetching player data:", error);
        setPlayer(null);
      } finally {
        setLoading(false);
      }
    };

    if (bsa_number) {
      fetchPlayerData();
    }
  }, [bsa_number]);
  const handlePlayerEdit = () => {
    setEditingPlayer(true);
  };

  const handlePlayerSave = async () => {
    try {
      // TODO: Implement updatePlayer service function
      console.log("Saving player:", playerForm);
      setPlayer(playerForm);
      setEditingPlayer(false);
    } catch (error) {
      console.error("Error updating player:", error);
    }
  };

  const handlePlayerCancel = () => {
    setPlayerForm(player);
    setEditingPlayer(false);
  };

  const handleAddEntry = () => {
    setEntryDialog({ open: true, editEntry: null });
  };

  const handleEditEntry = (entry) => {
    console.log("Opening edit dialog for entry:", entry);
    setEntryDialog({ open: true, editEntry: entry });
  };

  const handleEntryUpdated = async (updatedEntry) => {
    try {
      if (entryDialog.editEntry) {
        // Edit mode - update existing entry in the list
        setEntries(
          entries.map((e) => (e.id === updatedEntry.id ? updatedEntry : e))
        );
      } else {
        // Add mode - add new entry to the list
        setEntries([...entries, updatedEntry]);
      }

      // Close dialog
      setEntryDialog({ open: false, editEntry: null });

      // Reload player performance data to update metrics
      // const updatedPlayerResponse = await getPlayerByBsa(bsa_number);
      // if (updatedPlayerResponse && updatedPlayerResponse.player) {
      //   const updatedPlayerData = {
      //     ...player, // Keep existing data
      //     rank: updatedPlayerResponse.player.rank,
      //     total_points: updatedPlayerResponse.player.total_points,
      //     qualifying_events: Array.isArray(
      //       updatedPlayerResponse.player.qualifying_events
      //     )
      //       ? updatedPlayerResponse.player.qualifying_events.length
      //       : updatedPlayerResponse.player.qualifying_events || 0,
      //   };
      //   setPlayer(updatedPlayerData);
      //   setPlayerForm(updatedPlayerData);
      // }

      // Show success feedback
      setFeedback({
        open: true,
        message: entryDialog.editEntry
          ? "Entry updated successfully"
          : "Entry added successfully",
        severity: "success",
      });
    } catch (error) {
      console.error("Error processing entry:", error);
      // Show error feedback
      setFeedback({
        open: true,
        message: entryDialog.editEntry
          ? "Failed to update entry. Please try again."
          : "Failed to add entry. Please try again.",
        severity: "error",
      });
    }
  };

  const handleDeleteClick = (type, item) => {
    setDeleteDialog({
      open: true,
      type,
      item,
    });
  };

  const handleConfirmDelete = async () => {
    setIsDeleting(true);
    try {
      const userName = getUserName(user);
      if (deleteDialog.type === "player") {
        // await deletePlayer(
        //   deleteDialog.item.id,
        //   user?.id,
        //   user?.email,
        //   userName
        // );
        navigate("/players");
      } else if (deleteDialog.type === "entry") {
        dispatch(deleteEntry(deleteDialog.item.id));

        // Reload player performance data to update metrics
        // const updatedPlayerResponse = await getPlayerByBsa(bsa_number);
        // if (updatedPlayerResponse && updatedPlayerResponse.player) {
        //   const updatedPlayerData = {
        //     ...player, // Keep existing data
        //     rank: updatedPlayerResponse.player.rank,
        //     total_points: updatedPlayerResponse.player.total_points,
        //     qualifying_events: Array.isArray(
        //       updatedPlayerResponse.player.qualifying_events
        //     )
        //       ? updatedPlayerResponse.player.qualifying_events.length
        //       : updatedPlayerResponse.player.qualifying_events || 0,
        //   };
        //   setPlayer(updatedPlayerData);
        //   setPlayerForm(updatedPlayerData);
        // }
        // Show success feedback
        setFeedback({
          open: true,
          message: "Entry deleted successfully",
          severity: "success",
        });
      }
    } catch (error) {
      console.error("Error deleting:", error);
      // Show error feedback
      setFeedback({
        open: true,
        message: "Failed to delete entry. Please try again.",
        severity: "error",
      });
    }
    setIsDeleting(false);
    setDeleteDialog({ open: false, type: null, item: null });
  };

  const calculateTotalPoints = () => {
    return entries.reduce(
      (total, entry) => total + (parseInt(entry.points) || 0),
      0
    );
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ mt: 4 }}
      >
        <CircularProgress />
        <Typography variant="body1" sx={{ ml: 2 }}>
          Loading player details...
        </Typography>
      </Box>
    );
  }

  if (!player) {
    return (
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" color="error">
          Player not found
        </Typography>
        <Button onClick={() => navigate("/players")} sx={{ mt: 2 }}>
          Back to Players
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      {/* Header */}
      <Box display="flex" alignItems="center" gap={2} sx={{ mb: 3 }}>
        <IconButton onClick={() => navigate("/players")}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h4" component="h1">
          Player Profile
        </Typography>
      </Box>

      {/* Player Information Card */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Box
            display="flex"
            justifyContent="between"
            alignItems="center"
            sx={{ mb: 2 }}
          >
            <Typography variant="h6">Player Information</Typography>
            <Box>
              {!editingPlayer ? (
                <>
                  <IconButton onClick={handlePlayerEdit}>
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => handleDeleteClick("player", player)}
                    color="error"
                  >
                    <DeleteIcon />
                  </IconButton>
                </>
              ) : (
                <>
                  <IconButton onClick={handlePlayerSave} color="primary">
                    <SaveIcon />
                  </IconButton>
                  <IconButton onClick={handlePlayerCancel}>
                    <CancelIcon />
                  </IconButton>
                </>
              )}
            </Box>
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              {editingPlayer ? (
                <TextField
                  fullWidth
                  label="First Name"
                  value={playerForm.firstName}
                  onChange={(e) =>
                    setPlayerForm({ ...playerForm, firstName: e.target.value })
                  }
                />
              ) : (
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    First Name
                  </Typography>
                  <Typography variant="body1">{player.firstName}</Typography>
                </Box>
              )}
            </Grid>

            <Grid item xs={12} md={6}>
              {editingPlayer ? (
                <TextField
                  fullWidth
                  label="Last Name"
                  value={playerForm.lastName}
                  onChange={(e) =>
                    setPlayerForm({ ...playerForm, lastName: e.target.value })
                  }
                />
              ) : (
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Last Name
                  </Typography>
                  <Typography variant="body1">{player.lastName}</Typography>
                </Box>
              )}
            </Grid>

            <Grid item xs={12} md={6}>
              {editingPlayer ? (
                <TextField
                  fullWidth
                  label="Email"
                  value={playerForm.email}
                  onChange={(e) =>
                    setPlayerForm({ ...playerForm, email: e.target.value })
                  }
                />
              ) : (
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Email
                  </Typography>
                  <Typography variant="body1">
                    {player.email || "N/A"}
                  </Typography>
                </Box>
              )}
            </Grid>

            <Grid item xs={12} md={6}>
              {editingPlayer ? (
                <TextField
                  fullWidth
                  label="BSA Number"
                  value={playerForm.bsa_number}
                  onChange={(e) =>
                    setPlayerForm({ ...playerForm, bsa_number: e.target.value })
                  }
                />
              ) : (
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    BSA Number
                  </Typography>
                  <Typography variant="body1">
                    {player.bsa_number || "N/A"}
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>

          <Divider sx={{ my: 2 }} />

          {/* Performance Summary */}
          <Grid container spacing={2}>
            <Grid item xs={6} md={2}>
              <Box textAlign="center">
                <Typography variant="h4" color="primary">
                  #{player.rank || "N/A"}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Current Rank
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6} md={2}>
              <Box textAlign="center">
                <Typography variant="h4" color="success.main">
                  {Math.round(player.total_points || 0)}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Ranking Points
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6} md={2}>
              <Box textAlign="center">
                <Typography variant="h4" color="warning.main">
                  {player.qualifying_events || 0}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Qualifying Events
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6} md={2}>
              <Box textAlign="center">
                <Typography variant="h4" color="info.main">
                  {entries.length}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Total Events
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6} md={2}>
              <Box textAlign="center">
                <Typography variant="h4" color="secondary.main">
                  {calculateTotalPoints()}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Raw Points
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6} md={2}>
              <Box textAlign="center">
                <Chip
                  label={
                    (player.qualifying_events || 0) >= 5 ? "Active" : "Inactive"
                  }
                  color={
                    (player.qualifying_events || 0) >= 5 ? "success" : "default"
                  }
                  variant="outlined"
                />
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                >
                  Status
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Entries Section */}
      <Paper elevation={3}>
        <Box p={2}>
          <Box
            display="flex"
            justifyContent="between"
            alignItems="center"
            gap={2}
            sx={{ mb: 2 }}
          >
            <Typography variant="h6">Competition Entries</Typography>
            <Button
              startIcon={<AddIcon />}
              variant="contained"
              onClick={handleAddEntry}
            >
              Add Entry
            </Button>
          </Box>

          {/* Add Entry Dialog */}
          <AddEntryDialog
            open={entryDialog.open}
            onClose={() => setEntryDialog({ open: false, editEntry: null })}
            onEntryAdded={handleEntryUpdated}
            playerId={player.id}
            editEntry={entryDialog.editEntry}
          />

          {/* Entries Table */}
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Event</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Position</TableCell>
                <TableCell>District</TableCell>
                <TableCell>Points</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {entries.map((entry) => (
                <TableRow key={entry.id}>
                  <TableCell>{entry.event}</TableCell>
                  <TableCell>{formatDate(entry.event_date)}</TableCell>
                  <TableCell>
                    {entry.category?.name || entry.category || "N/A"}
                  </TableCell>
                  <TableCell>
                    {entry.position?.name || entry.position || "N/A"}
                  </TableCell>
                  <TableCell>{entry.district || "N/A"}</TableCell>
                  <TableCell>
                    <Typography fontWeight="bold" color="primary">
                      {entry.points}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Box display="flex" gap={1} alignItems="center">
                      {entry.bowlscout_import === null ? (
                        <>
                          <IconButton
                            onClick={() => handleEditEntry(entry)}
                            size="small"
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => handleDeleteClick("entry", entry)}
                            color="error"
                            size="small"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </>
                      ) : (
                        <Box display="flex" alignItems="center" gap={1}>
                          <img
                            src={BowlScoutImage}
                            alt="BowlScout"
                            style={{ width: 20, height: 20 }}
                          />
                          <Typography variant="caption" color="text.secondary">
                            Imported
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
              {entries.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <Typography color="text.secondary">
                      No entries found for this player.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </Paper>

      {/* Activity Log Section */}
      <Box sx={{ mt: 3 }}>
        <ActivityTable playerId={player.id} />
      </Box>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialog.open}
        onClose={() => setDeleteDialog({ open: false, type: null, item: null })}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this {deleteDialog.type}? This
            action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setDeleteDialog({ open: false, type: null, item: null })
            }
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
            disabled={isDeleting}
            startIcon={
              isDeleting ? <CircularProgress size={20} color="inherit" /> : null
            }
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Feedback Snackbar */}
      <Snackbar
        open={feedback.open}
        autoHideDuration={4000}
        onClose={() => setFeedback({ ...feedback, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setFeedback({ ...feedback, open: false })}
          severity={feedback.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {feedback.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default Player;
